import * as actions from '../../actions/actions'

const initialState = {
  userDetail: {
    idBank: '',
    corporateSenderId: '',
    fullName: '',
    description: '',
    enable: true,
    username: '',
    phone: '',
    email:'',
    reset: true,
    password: '',
    imageString:'',
    bankName:'',
    corporateName:''
  },
  error: ''
}

export default function userDetail(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_USER_DETAIL_SUCCESS:
      return fetchUserDetailSuccess(state, action)
    case actions.FETCH_USER_DETAIL_FAILURE:
      return fetchUserDetailFailure(state, action)
    case actions.DETAIL_USER_CLEAN:
      return detailUserClean(state, action)
    default:
      return state
  }
}

const fetchUserDetailSuccess = (state, action) => {
  return {
    ...state,
    userDetail: action.value
  }
}

const fetchUserDetailFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const detailUserClean = (state, action) => {
  return initialState;
}